<template>
  <div class="flex">
    <base-input
              :value="value"
              :placeholder="placeholder"
              ref="input"
              @input="onInput"
              :color="focusColor"
              :key="refreshKey"
              class="w-full"
              :class="{'border-focus-error focus:border-focus-error': hasError}"
              variant="editor-centered" />
  </div>
</template>

<script>
import tailwind from '../../../tailwind.config'

export default {
  name: 'TimeInput',

  props: {
    value: {
      type: String,
      required: true
    },
    hasError: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String
    }
  },

  data() {
    return {
      refreshKey: 0
    }
  },

  computed: {
    focusColor() {
      return tailwind.theme.colors.focus
    }
  },

  methods: {
    limitHHMM(time) {
      const [hours = '', mins = ''] = time.split(':')
      const limitDigits = digits => digits.substring(0, 2)
      return limitDigits(hours) + ':' + limitDigits(mins)
    },

    onInput(time) {
      if (time.length < 2 || time.includes('$')) {
        this.$emit('change', time)
        return
      }

      if (time.length > 5) {
        this.refreshKey = Math.random()
        return
      }

      this.$emit('change', this.limitHHMM(time))
    }
  },

  watch: {
    hasError: {
      immediate: false,
      handler(hasError) {
        if (hasError) this.$refs.input.focus()
      }
    }
  },

  mounted() {
    if (this.autofocus) this.$refs.input.focus()
  }
}
</script>

